import React, { Component } from "react";
import {
  Icon,
  Segment,
  Message,
  Header,
  Button,
  Label,
  Item,
  Table,
} from "semantic-ui-react";
import axios from "axios";
import { DocumentButtons } from "./DocumentButtons";
import { DocumentPreview } from "./DocumentPreview";
import { DocumentRejections } from "./DocumentRejections";

import SendPAF from "./SendPAF";

let baseUrl = "dealer";

const needsUpload = (file) => {
  if (!file) {
    return true;
  }

  if (!file.filename) {
    return true;
  }

  if (file.resubmitted) {
    return false;
  }

  if (file.rejection_notes.find((r) => !r.fixed)) {
    return true;
  }

  return false;
};

export default class ContractFinalize extends Component {
  state = {
    error: null,
    loading: false,
    billOfSale: null,
    preview: null,
    signedAch: null,
    systems: [],
  };

  componentDidMount = () => {
    this.fetchData();
  };

  fetchData = () => {
    this.setState({
      loading: true,
    });

    axios
      .get(`/contracts/${this.props.contractId}/`)
      .then(({ data }) => {
        this.setState({
          loading: false,
          systems: data.hvac_systems,
          billOfSale: data.bill_of_sale ? data.bill_of_sale : null,
          signedAch: data.signed_ach_authorization_image
            ? data.signed_ach_authorization_image
            : null,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  onDocUpload = (e, docName, systemId) => {
    const formData = new FormData();
    let postUrl = "";

    formData.append("contract_id", this.props.contractId);

    switch (docName) {
      case "bill_of_sale":
        formData.append("bill_of_sale", e.target.files[0]);
        postUrl = "/images/bill-of-sale/";
        break;
      case "signed_ach_authorization_image":
        formData.append("signed_ach_authorization", e.target.files[0]);
        postUrl = "/images/signed-ach-authorization/";
        break;
      case "registration_certificate_image":
        const system = this.state.systems.find((s) => s.id === systemId);

        if (!system) {
          return;
        }

        formData.append("registration_certificate", e.target.files[0]);
        formData.append("hvac_system_id", systemId);

        if (system.registration_certificate_images.length) {
          formData.append(
            "registration_certificate_id",
            system.registration_certificate_images[0].id
          );
        }

        postUrl = "/images/registration-certificate/";
        break;
      default:
        break;
    }

    if (!postUrl) {
      return;
    }

    this.setState({ loading: true, error: null });

    axios
      .post(postUrl, formData)
      .then(({ data }) => this.fetchData())
      .catch((err) => {
        this.setState({
          error: err.response.data.ui_message,
          loading: false,
        });
      });
  };

  onDocRemove = (docName, filename) => {
    let postUrl = "";
    switch (docName) {
      case "bill_of_sale":
        postUrl = "/images/bill-of-sale/";
        break;
      case "signed_ach_authorization_image":
        postUrl = "/images/signed-ach-authorization/";
        break;
      case "registration_certificate_image":
        postUrl = "/images/registration-certificate/";
        break;
      default:
        break;
    }

    if (!postUrl) {
      return;
    }

    this.setState({ loading: true, error: null });

    axios
      .delete(`${postUrl}/${filename}`)
      .then(() => this.fetchData())
      .catch((err) => {
        this.setState({
          error: err.response.data.ui_message,
          loading: false,
        });
      });
  };

  onPreviewClick = (url) => {
    this.setState({ preview: url });
  };

  onPreviewClose = () => this.setState({ preview: null });

  render() {
    const {
      dealerPayoutSystems,
      dealerPayoutAdditionalMaterials,
      dealerPayoutTotal,
    } = this.props;
    const { loading, billOfSale, signedAch } = this.state;

    let imageItems = [
      {
        label: "Bill of Sale",
        name: "bill_of_sale",
        attachment: billOfSale,
        path: "bill-of-sale",
        entity: "BillOfSale",
        document_type: "bill_of_sale_id",
        id: "billOfSale",
      },
      {
        label: "Signed Payment Authorization Form (PAF)",
        name: "signed_ach_authorization_image",
        attachment: signedAch,
        path: "signed-ach-authorization",
        entity: "SignedAchAuthorizationImage",
        document_type: "signed_ach_authorization_image_id",
        id: "signedAch",
      },
    ];

    if (this.state.systems.length > 0) {
      this.state.systems.forEach((sys) =>
        imageItems.push({
          label: `Equipment Registration Certificate for ${sys.name}`,
          name: "registration_certificate_image",
          attachment: sys.registration_certificate_images[0],
          path: "registration-certificate",
          entity: "RegistrationCertificateImage",
          document_type: "registration_certificate_image_id",
          id: `registration_certificate_image${sys.id}`,
          systemId: sys.id,
        })
      );
    }

    return (
      <Segment basic loading={this.state.loading}>
        {this.state.preview && (
          <DocumentPreview
            onClose={this.onPreviewClose}
            src={this.state.preview}
          />
        )}
        <Header as="h3">
          <Header.Content>
            <Icon name="upload" color="blue" />
            Document Upload
          </Header.Content>
          <Header.Subheader content="Please upload the following documents" />
        </Header>
        {this.state.error && (
          <Message
            size="large"
            negative
            icon="exclamation"
            header="There's a problem..."
            content={this.state.error}
          />
        )}
        <h3 style={{ marginBottom: "0" }}>Dealer Payout</h3>
        <p>Your bill of sale should look like the following...</p>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell content="" />
              <Table.HeaderCell content="Amount" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {dealerPayoutSystems.map(
              ({ id, name, dealer_payout_formatted }) => (
                <Table.Row key={id}>
                  <Table.Cell content={name} />
                  <Table.Cell content={`$${dealer_payout_formatted}`} />
                </Table.Row>
              )
            )}
            {/* {dealerPayoutAdditionalMaterials !== null &&
              dealerPayoutAdditionalMaterials !== 0 && (
                <Table.Row
                  cells={[
                    `Additional Cost`,
                    `$${dealerPayoutAdditionalMaterials}`,
                  ]}
                />
              )} */}
            <Table.Row cells={["Total", `$${dealerPayoutTotal}`]} />
          </Table.Body>
        </Table>
        <Item.Group divided>
          {imageItems.map((item, i) => (
            <Item key={i}>
              <Item.Image
                as={() => (
                  <Icon
                    name={
                      !item.attachment || !item.attachment.filename
                        ? "question"
                        : "file"
                    }
                    size="huge"
                    style={{ marginRight: "15px" }}
                    color={
                      !item.attachment || !item.attachment.accepted
                        ? "red"
                        : "green"
                    }
                  />
                )}
              />
              <Item.Content verticalAlign="middle">
                <Item.Header content={item.label} />
                {!needsUpload(item.attachment) && item.attachment.accepted && (
                  <Item.Meta content="Accepted" />
                )}
                {!needsUpload(item.attachment) && !item.attachment.accepted && (
                  <Item.Meta content="Under Review" />
                )}
                {needsUpload(item.attachment) && (
                  <div>
                    <Item.Description style={{ marginTop: "5px" }}>
                      {!item.attachment && <p>This document is missing.</p>}
                    </Item.Description>
                  </div>
                )}
                {item.entity === "SignedAchAuthorizationImage" && (
                  <React.Fragment>
                    {(!item.attachment || !item.attachment.accepted) && (
                      <Item.Description>
                        <SendPAF
                          contractId={this.props.contractId}
                          onSuccess={this.fetchData}
                          resending={item.attachment ? true : false}
                        />
                      </Item.Description>
                    )}
                    {item.attachment &&
                      item.attachment.dealer_name &&
                      !item.attachment.accepted && (
                        <Label
                          content="Sent to Renter"
                          icon="check circle"
                          style={{ marginTop: "10px" }}
                        />
                      )}
                  </React.Fragment>
                )}
                {item.attachment &&
                  !item.attachment.resubmitted &&
                  item.attachment.rejection_notes.find((r) => !r.fixed) && (
                    <Item.Description style={{ marginTop: "20px" }}>
                      <DocumentRejections
                        accepted={item.attachment.accepted}
                        divider={false}
                        title="Rejections"
                        rejections={item.attachment.rejection_notes}
                      />
                    </Item.Description>
                  )}
                {item.entity !== "SignedAchAuthorizationImage" && (
                  <React.Fragment>
                    {needsUpload(item.attachment) && (
                      <Item.Extra style={{ marginTop: "10px" }}>
                        <Button
                          as="label"
                          icon="upload"
                          size="tiny"
                          content="Upload"
                          color="blue"
                          htmlFor={item.id}
                        />
                        <input
                          hidden
                          id={item.id}
                          accept=".pdf,.jpg,.png"
                          name={item.name}
                          type="file"
                          onChange={(e) =>
                            this.onDocUpload(e, item.name, item.systemId)
                          }
                        />
                      </Item.Extra>
                    )}
                  </React.Fragment>
                )}
                {!needsUpload(item.attachment) && (
                  <Item.Extra style={{ marginTop: "20px" }}>
                    <DocumentButtons
                      accepted={item.attachment.accepted}
                      docClass={item.entity}
                      docType={item.document_type}
                      id={item.attachment.id}
                      filename={item.attachment.filename}
                      name={item.label}
                      onDeleteClick={() =>
                        this.onDocRemove(item.name, item.attachment.filename)
                      }
                      onPreviewClick={this.onPreviewClick}
                      size="small"
                      url={`/${baseUrl}/api/images/${item.path}/${item.attachment.filename}`}
                    />
                  </Item.Extra>
                )}
              </Item.Content>
            </Item>
          ))}
        </Item.Group>
      </Segment>
    );
  }
}

ContractFinalize.defaultProps = {
  dealerPayoutSystems: [],
  dealerPayoutAdditionalMaterials: "",
  dealerPayoutTotal: "",
};
